import { useGT } from 'gt-react';
import { Button } from 'src/components/ui/button';

/** Cancel and Save for an inline override editor, however it is laid out. */
export function OverrideActions({
  canSave,
  onCancel,
  onSave,
}: {
  canSave: boolean;
  onCancel: () => void;
  onSave: () => void;
}) {
  const gt = useGT();
  return (
    <>
      <Button size="sm" variant="outline" onClick={onCancel}>
        {gt('Cancel', { context: 'inline override cancel button' })}
      </Button>
      <Button size="sm" disabled={!canSave} onClick={onSave}>
        {gt('Save Override', { context: 'inline override save button' })}
      </Button>
    </>
  );
}
